import React, { useState } from 'react';
import { ThemeProvider, createTheme, CssBaseline, AppBar, Toolbar, Typography, Box } from '@mui/material';
import PasswordGenerator from './components/PasswordGenerator';
import ThemeToggle from './components/ThemeToggle';

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const theme = createTheme({ palette: { mode: darkMode ? 'dark' : 'light' } });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppBar position="static">
        <Toolbar sx={{ flexDirection: 'column', alignItems: 'flex-start', py: 2 }}>
          <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
            <Typography variant="h4" sx={{ flexGrow: 1, fontWeight: 'bold', letterSpacing: 1 }}>
              Passwordly
            </Typography>
            <ThemeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
          </Box>
          <Typography
            variant="subtitle1"
            sx={{
              color: theme =>
                theme.palette.mode === 'dark'
                  ? theme.palette.text.secondary
                  : theme.palette.primary.contrastText,
              opacity: 0.85,
              fontSize: { xs: '0.95rem', sm: '1.1rem' },
              mt: 0.5,
              ml: 0.2,
              fontWeight: 400,
            }}
          >
            A secure, easy-to-use random password generator that creates memorable passwords for your online accounts.
          </Typography>
        </Toolbar>
      </AppBar>
      <PasswordGenerator />
    </ThemeProvider>
  );
}

export default App;
